import { defineStore } from "pinia";
import { BuildingData, UnitData } from "./app-state";

export const appStore = defineStore('counterStore', {
    state: () => ({
      siteSVG: '',
      floorplanFilter: '',
      statusFilter: '',
      unitsData: [] as UnitData[],
      futurePhaseBuildings: [] as BuildingData[],
  })
});